<template>
  <ux-modal no-cross>
    <ux-text
      v-if="isIsinsModal"
      tag="p"
      bold
    >
      Choisir un ou des ISIN(S) va effacer votre saisie de libellé, êtes-vous sûr de vouloir poursuivre ?
    </ux-text>
    <ux-text
      v-if="!isIsinsModal"
      tag="p"
      bold
    >
      Saisir un libellé va effacer votre saisie d'ISIN(S), êtes vous sûr de vouloir poursuivre ?
    </ux-text>
    <ux-btn-group slot="footer">
      <ux-btn
        model="secondary"
        @click="onSubmit()"
        >Continuer</ux-btn
      >
      <ux-btn
        model="primary"
        @click="onCancel()"
        >Annuler</ux-btn
      >
    </ux-btn-group>
  </ux-modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    isIsinsModal: Boolean,
  },
  emits: ['actionModal'],
  data: function () {
    return {
      isIsins: false,
    }
  },
  methods: {
    onCancel() {
      this.$emit('actionModal', { action: 'close' })
    },
    onSubmit() {
      this.$emit('actionModal', { action: 'reset' })
    },
  },
})
</script>
